import { SEOHead } from '../components/SEOHead';
import { IPhoneFrame } from '../components/IPhoneFrame';
import { AppNavigationBar } from '../components/AppNavigationBar';
import { Smartphone } from 'lucide-react';

export default function AppNav() {
  return (
    <>
      <SEOHead title="App Navigation – pixcapture.app" description="App-Navigation testen" path="/app/nav" />
      <IPhoneFrame>
        <div className="relative w-full h-full bg-gradient-to-br from-[#74A4EA] to-[#64BF49] flex flex-col items-center justify-center text-white">
          <Smartphone className="h-24 w-24 mb-6 opacity-80" />
          <h1 className="text-[32px] mb-2">pixcapture.app</h1>
          <p className="text-white/80 text-center px-8">
            Navigiere mit der unteren Leiste
          </p>

          <AppNavigationBar activeRoute="/app/jobs" orientation="portrait" />
        </div>
      </IPhoneFrame>
    </>
  );
}
